import React from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import RefreshIcon from '@mui/icons-material/Refresh';
import SendIcon from '@mui/icons-material/Send';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

interface LinkActionsMenuProps {
  anchorEl: HTMLElement | null;
  item: any;
  canSend: boolean;
  isFinal: boolean;
  onClose: () => void;
  runAction: (action: (item: any) => void) => void;
  onCopy: (link: string) => void;
  onOpenCheckout: (link: string) => void;
  onSend: (item: any) => void;
  onRefresh: (item: any) => void;
}

export const LinkActionsMenu = ({
  anchorEl,
  item,
  canSend,
  isFinal,
  onClose,
  runAction,
  onCopy,
  onOpenCheckout,
  onSend,
  onRefresh,
}: LinkActionsMenuProps) => (
  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
  >
    <MenuItem
      disabled={!item?.link_url}
      onClick={() => runAction((link) => onCopy(link.link_url))}
    >
      <ListItemIcon>
        <ContentCopyIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Copiar link</ListItemText>
    </MenuItem>
    <MenuItem
      disabled={!item?.link_url}
      onClick={() => runAction((link) => onOpenCheckout(link.link_url))}
    >
      <ListItemIcon>
        <OpenInNewIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Abrir página de pagamento</ListItemText>
    </MenuItem>
    {canSend && (
      <MenuItem onClick={() => runAction((link) => onSend(link))}>
        <ListItemIcon>
          <SendIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Enviar ao cliente</ListItemText>
      </MenuItem>
    )}
    <MenuItem
      disabled={isFinal}
      onClick={() => runAction((link) => onRefresh(link))}
    >
      <ListItemIcon>
        <RefreshIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>
        {isFinal ? 'Situação encerrada' : 'Atualizar situação'}
      </ListItemText>
    </MenuItem>
  </Menu>
);

export default LinkActionsMenu;
